<template>
  <v-container>
    <v-card>
      <v-card-title>
        Kompanije
      </v-card-title>
      <v-card-subtitle>
        <v-row justify="end">
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
              v-model="query"
              append-icon="mdi-magnify"
              label="Pretraga"
              single-line
              hide-details
              clearable
              @keyup.enter.prevent='onEnterSearch'
              @click:clear='onClearSearch()'
            ></v-text-field>
          </v-col>
        </v-row>
        <company-filters
          @apply-filters="onApplyFilters"
          @reset-filters="onResetFilters"
        />
      </v-card-subtitle>
      <v-data-table
      :headers="headers"
      :items="listOfCompanies"
      :server-items-length="totalCompaniesCount"
      :options.sync="options"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-text': 'Broj redova po stranici:'
      }"
      no-data-text="Nema rezultata"
      loading-text="Učitavanje podataka... Molimo sačekajte"
      class="elevation-1 row-pointer"
      width="100%"
      @click:row="onRowClick"
      >
        <template v-slot:[`item.active`]="{ item }">
          <v-avatar :color="getActiveColor(item)" size="15"></v-avatar>
        </template>

        <template v-slot:[`item.subscriptionState`]="{ item }">
          {{ getSubscriptionStateText(item.subscriptionState) }}
        </template>

      </v-data-table>
    </v-card>
    <v-card-actions class="justify-end pa-4">
      <v-btn
        color="success"
        :loading="exportLoading"
        @click="downloadExcel"
      >
        <v-icon left>
          mdi-microsoft-excel
        </v-icon>

        Preuzmi Excel
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import * as apiCompanies from '../api/companies.js';
import * as utils from '../utils.js';

import CompanyFilters from './CompaniesAdvancedFilters.vue';

export default {
  name: "CompaniesList",
  components: {
    CompanyFilters
  },
  data: function () {
    return {
      loading: false,
      exportLoading: false,
      options: {
        sortDesc: [true]
      },
      isSearchByID: false,
      listOfCompanies: [],
      query: "",
      totalCompaniesCount: 0,
      headers: [
          { text: 'ID', value: 'id', width: "5%" },
          { text: 'PIB', value: 'tid', width: "10%" },
          { text: 'MB', value: 'mn', width: "10%" },
          { text: 'Naziv', value: 'name', width: "30%" },
          { text: 'Adresa', value: 'address', width: "30%" },
          { text: 'Grad', value: 'town', width: "10%" },
          { text: 'Aktivna', value: 'active', width: "5%" }
      ],
      advancedFilters: {
        query: ''
      }
    }
  },
  mounted () {
    this.getCompaniesFromAPI()
  },
  watch: {
    options: {
      handler () {
        this.getCompaniesFromAPI();
      },
      deep: true,
    }
  },
  methods: {
    getCompaniesFromAPI() {
      this.loading = true;

      console.log(this.advancedFilters);

      apiCompanies.advancedSearch(
        this.options,
        this.advancedFilters,
        this.$store.getters.token
      )
        .then(response => response.json())
        .then(responseData => {
          this.loading = false;
          this.listOfCompanies = responseData.companies;
          this.totalCompaniesCount = responseData.totalCount;
        })
        .catch(() => {
          this.listOfCompanies = [];
          this.loading = false;
          this.totalCompaniesCount = 0;
        })
    },

    getSubscriptionStateText(subscriptionState) {
      return utils.getSubscriptionStateText(subscriptionState);
    },

    onEnterSearch() {
      this.options.page = 1;
      this.advancedFilters.query = this.query;
      this.getCompaniesFromAPI();
    },

    onClearSearch() {
      this.query = '';
      this.advancedFilters.query = '';
      this.getCompaniesFromAPI();
    },

    onApplyFilters(filters) {
      this.advancedFilters = filters;
      this.options.page = 1;
      this.getCompaniesFromAPI();
    },

    onResetFilters() {
      this.advancedFilters = {};
      this.options.page = 1;
      this.getCompaniesFromAPI();
    },

    onRowClick(company) {
      let route = this.$router.resolve({ path: '/companies/' + company.id });
      window.open(route.href, '_blank');
    },

    getActiveColor(item) {
      if (item.active)
        return "success";
      else
        return "error";
    },
    async downloadExcel() {
      try {
        this.exportLoading = true;

        const response = await apiCompanies.exportAdvancedSearch(
          this.advancedFilters,
          this.$store.getters.token
        );

        const blob = await response.blob();

        let fileName = 'companies.xlsx';

        const contentDisposition = response.headers.get('content-disposition');

        if (contentDisposition) {
          const utf8FileNameMatch = contentDisposition.match(
            /filename\*=UTF-8''([^;]+)/
          );

          const asciiFileNameMatch = contentDisposition.match(
            /filename="?([^"]+)"?/
          );

          if (utf8FileNameMatch && utf8FileNameMatch[1]) {
            fileName = decodeURIComponent(utf8FileNameMatch[1]);
          }
          else if (asciiFileNameMatch && asciiFileNameMatch[1]) {
            fileName = asciiFileNameMatch[1];
          }
        }

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);

        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.exportLoading = false;
      }
    },
  }
}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
